import { render } from "./Question.vue?vue&type=template&id=c961d8dc&scoped=true"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"

import "./Question.vue?vue&type=style&index=0&id=c961d8dc&scoped=true&lang=css"

import exportComponent from "C:\\0_PROJECTS\\EcoSim\\Csongrad\\sar_es_tuz\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c961d8dc"]])

export default __exports__